"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Query builder for the home page
 *
 * @returns {object} Contentful query
 */

var pages = {
  1: 'page',
  2: 'page_v2'
};
var homePage = function homePage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 1 : _ref$version;
  return {
    content_type: pages[version],
    'fields.pageType': 'home'
  };
};
var _default = homePage;
exports["default"] = _default;